import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSticker: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconSticker"><Path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.47715 6.47715 2 12 2C12.1184 2 12.2363 2.00206 12.3537 2.00615C13.0265 2.02956 13.6208 2.33881 14.0546 2.77265L21.2274 9.94537C21.6612 10.3792 21.9704 10.9735 21.9939 11.6463C21.9979 11.7637 22 11.8816 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM20.5 11.4506C16.0039 11.9923 12.0078 7.99591 12.5494 3.5L20.5 11.4506Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSticker;
